// extracted by mini-css-extract-plugin
module.exports = {"grid":"main_grid__3bHFM"};